module.exports = __webpack_public_path__ + "img/鸟瞰图.ea9cd72a.png";